export default "__VITE_ASSET__dc3447df__"